import TicketProgress from './TicketProgress';

export { TicketProgress };
export default TicketProgress;
